import React, { useEffect } from 'react'
import { ClickAwayListener, Dialog, ListItem, ListItemButton, ListItemIcon, Typography, useMediaQuery, Tooltip } from '@mui/material'
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box'
import MuiDrawer from '@mui/material/Drawer'
import MuiList from '@mui/material/List'
import CssBaseline from '@mui/material/CssBaseline'
import MuiAppBar from '@mui/material/AppBar'
import List from '@mui/material/List'
import Login from '../Login/Login'
import { appTheme } from '../../theme'
import LogoutIcon from '@mui/icons-material/Logout'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import CalendarIcon from '@mui/icons-material/CalendarToday'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import GroupsIcon from '@mui/icons-material/Groups'
import DomainIcon from '@mui/icons-material/Domain'
import HelpIcon from '@mui/icons-material/Help'
import { makeStyles } from '@mui/styles'
import { useNavigate, useLocation } from 'react-router-dom'
//import { useAuthState } from '../Auth/AuthProvider'

import calendar from '../../images/icons-calendar.svg'
import eventCalendar from '../../images/eventCalendar.svg'
import calendar_active from '../../images/icons-calendar-active.svg'
import eventCalendar_active from '../../images/eventCalendar-active.svg'

import Signup from '../Signup/Signup'
import ForgotPassword from '../ForgotPassword/ForgotPassword'
import { ResetPassword } from '../ResetPassword'
import { Role } from '../../services/Types'
import { userData } from '../../services/AuthService'
import { NavListItem } from '../NavListItem/NavListItem'

import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { SiteIcon } from '../SiteIcon/SiteIcon';
import { PestControl } from '@mui/icons-material';

const drawerWidth = 240

var isMobView = true

declare module 'react' {
  interface HTMLAttributes<T> extends AriaAttributes, DOMAttributes<T> {
    open?: boolean
    profileMenu?: object
  }
}

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const Main = styled('main', { shouldForwardProp: prop => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginLeft: `-${drawerWidth}px !important`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen
      }),
      marginLeft: 0
    })
  })
)
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: prop => prop !== 'open'
})(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px !important)`,
    marginLeft: `${drawerWidth}px !important`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  })
}))

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
  backgroundColor: theme.palette.mode === 'dark' ? '#253D82' : '#fff'
}))

const MainMenuList = styled(MuiList, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: 80,
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);
const SecondaryMenuList = styled(MuiList, {})(
  ({ theme }) => ({
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    width: '175px',
  }),
);

const useStyles = makeStyles({
  loginBlock: {
    padding: '0 16px',
    textTransform: 'capitalize',
    fontSize: '18px',
    fontWeight: '400'
  },
  logo_text: {
    fontWeight: '300',
    letterSpacing: '2px'
  },
  app_logo: {
    marginRight: '16px',
    cursor: 'pointer'
  },
  logo_text_faded: {
    opacity: '0.5'
  },
  modalBox: {
    [appTheme.breakpoints.down('md')]: {
      top: `60px !important`,
      height: 'calc(100vh - 60px) !important'
    }
  },
  drawerPaper: {
    marginTop: '50px'
  }
})

const hasAdminAccess = (user: any | null): boolean => {
  return Boolean(user && (user.role === Role.ADMIN));
};

const hasApproverAccess = (user: any | null): boolean => {
  return Boolean(user && (user.role === Role.APPROVER));
};

const inRequest = (user: any | null): boolean => {
  return Boolean(user && (user.role === Role.REQUESTER));
};

export default function NavBar() {
  const location = useLocation()

  isMobView = useMediaQuery(appTheme.breakpoints.down('md'))

  useEffect(() => {
    if (location.state && location.state.showLogin) {
      handleOpen()
    }
  }, [location.state])
  const classes = useStyles()

  const theme = useTheme()
  const [open, setOpen] = React.useState(false)
  const [openAdmin, setOpenAdmin] = React.useState(false)
  const [openRequests, setOpenRequests] = React.useState(false)
  const [openAccounts, setOpenAccounts] = React.useState(false)
  const [openUsers, setOpenUsers] = React.useState(false)

  const navigate = useNavigate()

  const resetDrawer = () => {
    setOpenRequests(false)
    setOpenAccounts(false)
    setOpenUsers(false)
    setOpenAdmin(false)
  }
  // function to handle closing the drawer and navigating to a url
  const handleNavigate = (path: string, newTab: boolean = false) => {
    resetDrawer()
    setOpen(false)
    if (newTab) {
      window.open(path, '_blank')
    } else {
      navigate(path)
    }
  }

  const handleLogOut = () => {
    localStorage.removeItem('user')
    //updateAuthState(false)
    resetDrawer()
    setOpen(false)
    navigate('/')
    window.location.reload()
  }

  const handleOpenAdmin = () => {
    let openingAdmin = !openAdmin
    resetDrawer()
    setOpenAdmin(openingAdmin)
    setOpen(openingAdmin)
  }
  const handleOpenRequests = () => {
    let openingRequests = !openRequests
    resetDrawer()
    setOpenRequests(openingRequests)
    setOpen(openingRequests)
  }
  const handleOpenUsers = () => {
    let openingUsers = !openUsers
    resetDrawer()
    setOpenUsers(openingUsers)
    setOpen(openingUsers)
  }
  const handleOpenAccounts = () => {
    setOpenAccounts(!openAccounts)
  }

  // modal functionality
  const [openModal, setOpenModal] = React.useState(
    false || window.location.pathname.replace('/', '') === 'login'
  )
  const handleOpen = () => setOpenModal(true)
  const handleClose = () => {
    let user: any = localStorage.getItem('user')
    if (
      user !== 'null' &&
      user !== null &&
      location.state &&
      location.state.initialRoute &&
      location.state.initialRoute !== ''
    ) {
      navigate(location.state.initialRoute)
      location.state = undefined
    }
    setOpenModal(false)
  }

  const [signupModal, setSignupModal] = React.useState(false)
  const handleSignupOpen = () => setSignupModal(true)
  const handleSignupClose = () => setSignupModal(false)

  const [forgotPasswordModal, setForgotPasswordModal] = React.useState(false)
  const handleForgotPasswordOpen = () => setForgotPasswordModal(true)
  const handleForgotPasswordClose = () => setForgotPasswordModal(false)

  const [resetPasswordModal, setResetPasswordModal] = React.useState(false)
  const [resetPasswordEmail, setResetPasswordEmail] = React.useState('')
  const handleResetPasswordOpen = (email: string) => {
    setResetPasswordEmail(email)
    setResetPasswordModal(true)
  }
  const handleResetPasswordClose = () => setResetPasswordModal(false)

  const [auth, setAuth] = React.useState(true)
  const [username, setUsername] = React.useState('')
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseMenu = () => {
    setAnchorEl(null)
  }

  useEffect((): any => {
    let user: any = localStorage.getItem('user')

    if (user !== 'null' && user !== null) {
      user = JSON.parse(user)
      let username = user.firstName + ' ' + user.lastName
      setUsername(username)
      setAuth(true)
    } else {
      setAuth(false)
    }
  })

  const fullScreen = useMediaQuery(appTheme.breakpoints.down('md'))

  const AdminMainMenu = () => {
    return (
      <List>
        <NavListItem
          text="Admin"
          activeIcon={eventCalendar_active}
          inactiveIcon={eventCalendar}
          onClick={handleOpenAdmin}
          activePathPatterns={[
              '/admin',
            ]}
          />
      </List>
    )
  }

  const AdminSubMenu = () => {
    return (
      <Collapse in={openAdmin} timeout="auto" unmountOnExit>
        <List>
            <NavListItem
              horizontal={true}
              text="Events"
              activeIcon={<CalendarMonthIcon color="primary" />}
              inactiveIcon={<CalendarMonthIcon />}
              onClick={() => handleNavigate('/admin/events')}
              activePathPatterns={[
                  '/admin',
                  '/admin/events',
            ]}
            />

            <NavListItem
              horizontal={true}
              text="Accounts"
              activeIcon={<GroupsIcon color="primary" style={{ fontSize: '1.5em' }} />}
              inactiveIcon={<GroupsIcon style={{ fontSize: '1.5em' }}/>}
              onClick={handleOpenAccounts}
              activePathPatterns={[
                  '/admin/accounts/',
              ]}
            >
              {openAccounts ? <ExpandLess sx={{ fontSize: '1.5em' }} /> : <ExpandMore sx={{ fontSize: '1.5em' }} />}
            </NavListItem>


              <Collapse in={openAccounts} timeout="auto" unmountOnExit>
                <List>
                  <NavListItem
                    sx={{ pl: 2 }}
                    horizontal={true}
                    text="User Accounts"
                    activeIcon={<GroupsIcon color="primary" />}
                    inactiveIcon={<GroupsIcon/>}
                    onClick={() => handleNavigate('/admin/accounts/user')}
                    activePathPatterns={[
                        '/admin/accounts/',
                        '/admin/accounts/user',
                      ]}
                  />

                  <NavListItem
                    sx={{ pl: 2 }}
                    horizontal={true}
                    text="Program Offices"
                    activeIcon={<DomainIcon color="primary" />}
                    inactiveIcon={<DomainIcon/>}
                    onClick={() => handleNavigate('/admin/accounts/programOffices')}
                    activePathPatterns={[
                        '/admin/accounts/programOffices',
                      ]}
                  />
                </List>
              </Collapse>

              <NavListItem
                horizontal={true}
                text="Admin Scheduling"
                activeIcon={<CalendarIcon color="primary" />}
                inactiveIcon={<CalendarIcon/>}
                onClick={() => handleNavigate('/admin/booking/scheduler')}
                activePathPatterns={[
                    '/admin/booking/',
                  ]}
              />

        </List>
      </Collapse>
    )
  }

  const ApproverMainMenu = () => {
    return (
      <List>
        <NavListItem
          text="Events"
          activeIcon={eventCalendar_active}
          inactiveIcon={eventCalendar}
          onClick={() => handleNavigate('/admin/events')}
          activePathPatterns={[
            '/admin/events',
          ]}
        />
      </List>
    )
  }

  const RequestorMainMenu = () => {
    // once we have a submenu to show, then we'll `handleOpenRequests` onClick
    return (
      <List>
        <NavListItem
          text="Request"
          activeIcon={eventCalendar_active}
          inactiveIcon={eventCalendar}
          onClick={() => handleNavigate('/events')}
          activePathPatterns={[
            '/events',
            '/event/',
          ]}
        />
      </List>
    )
  }

  const RequestorSubMenu = () => {
    return (
      <Collapse in={openRequests} timeout="auto" unmountOnExit>
        <List>
          <ListItem sx={{ pl: 4 }}>
            <ListItemText primary="Event Overview" />
          </ListItem>

          <ListItem sx={{ pl: 4 }}>
            <ListItemText primary="Speakers & Support Staff" />
          </ListItem>

          <ListItem sx={{ pl: 4 }}>
            <ListItemText primary="Audience" />
          </ListItem>

          <ListItem sx={{ pl: 4 }}>
            <ListItemText primary="Dates & Times" />
          </ListItem>

          <ListItem sx={{ pl: 4 }}>
            <ListItemText primary="Features & Requests" />
          </ListItem>

          <ListItem sx={{ pl: 4 }}>
            <ListItemText primary="Review & Submit" />
          </ListItem>

        </List>
      </Collapse>
    )
  }

  const UsersSubMenu = () => {
    return (
      <Collapse in={openUsers} timeout="auto" unmountOnExit>
        <List>
          <NavListItem
            horizontal={true}
            text={getUsernameAndRole(username, user.role) }
            sx={{ paddingRight: '12px' }}
            activeIcon={<AccountCircleIcon color="primary" />}
            inactiveIcon={<AccountCircleIcon />}
            onClick={() => handleNavigate('/user/'+user.id)}
            activePathPatterns={[ '/user/'+user.id ]}
          />
          <NavListItem
            horizontal={true}
            text="Log Out"
            activeIcon={<LogoutIcon />}
            inactiveIcon={<LogoutIcon />}
            onClick={handleLogOut}
            activePathPatterns={['/logout']}
          />
        </List>
      </Collapse>
    )
  }

  function getUsernameAndRole(username: string, role: any) {
    return (
      <div style={{ width: '100%', maxWidth: '140px', paddingRight: '8px' }}>
        <Typography 
          variant="body1" 
          style={{
            margin: '0px', 
            padding: '0px 12px 0px 0px',
            textAlign: 'left',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            hyphens: 'auto',
            lineHeight: '1.2',
            fontSize: '14px'
          }}
        >
          {username}
        </Typography>
        <Typography variant="body2" style={{margin: '0px', textAlign: 'left', fontSize: '10px'}}>{role}</Typography>
      </div>
    );
  }

  let user: any = localStorage.getItem('user')
  if (user) user = JSON.parse(user)

  useEffect(() => {
    if (user) {
      const checkAuth = async () => {
        try {
          const { data } = await userData()
          if ([401, 404].includes(data.userData.statusCode)) {
            localStorage.removeItem('user')
            //updateAuthState(false)
            setOpenModal(true)
          } else {
            localStorage.setItem(
              'user',
              JSON.stringify({ ...user, ...data.userData.data })
            )
          }
        } catch (error) {
          console.log(error)
        }
      }

      checkAuth()
    }
  })

  let isAdminSection = user && (user.role === Role.ADMIN || user.role === Role.APPROVER)
  useEffect(() => {
    isAdminSection = Boolean(
      user && (user.role === Role.ADMIN || user.role === Role.APPROVER)
    )
  })
  let isDevEnvironment = window.location.hostname !== 'etaevents.safalapps.com'

  return (
    <>
      <Box sx={{ display: 'flex', flexGrow: 1 }}>
        <CssBaseline />

        <Dialog
          fullScreen={fullScreen}
          className={classes.modalBox}
          open={openModal}
          onClose={handleClose}
        >
          <Login
            classList={'hidden'}
            handleForgotPasswordOpen={handleForgotPasswordOpen}
            handleLoginOpen={handleOpen}
            handleSignupOpen={handleSignupOpen}
            handleResetPasswordOpen={handleResetPasswordOpen}
            modelClose={handleClose}
            loginPage={auth}
          />
        </Dialog>
        <Dialog
          fullScreen={fullScreen}
          className={classes.modalBox}
          open={signupModal}
          onClose={handleSignupClose}
        >
          <Signup
            classList={'hidden'}
            handleLoginOpen={handleOpen}
            modelClose={handleSignupClose}
            signupPage={auth}
          />
        </Dialog>
        <Dialog
          fullScreen={fullScreen}
          className={classes.modalBox}
          open={forgotPasswordModal}
          onClose={handleForgotPasswordClose}
        >
          <ForgotPassword
            classList={'hidden'}
            handleLoginOpen={handleOpen}
            modelClose={handleForgotPasswordClose}
            handleResetPasswordOpen={handleResetPasswordOpen}
            resetPasswordEmail={resetPasswordEmail}
          />
        </Dialog>

        <ResetPassword
          open={resetPasswordModal}
          onClose={handleResetPasswordClose}
          openLoginDialog={handleOpen}
          openForgotPasswordDialog={handleForgotPasswordOpen}
          resetPasswordEmail={resetPasswordEmail}
        />
      </Box>

      <Box>
        <ClickAwayListener
          mouseEvent='onMouseDown'
          touchEvent='onTouchStart'
          // open={open}
          onClickAway={() => open && setOpen(false)}
        >
          <Drawer
            sx={{
              width: drawerWidth,
              flexShrink: 0,
              '& .MuiDrawer-paper': {
                ...(isDevEnvironment && {
                  backgroundColor: '#fff8e1', // Light yellow tint for dev/qa environments
                }),
              },
            }}
            variant='permanent'
            anchor='left'
            open={open}
          >
            <DrawerHeader sx={{ 
              width: '100%', 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              justifyContent: 'center',
              backgroundColor: isDevEnvironment ? '#fff8e1' : undefined
            }}>
              <SiteIcon onClick={() => handleNavigate('/')} />
              {isDevEnvironment && (
                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 0.5, mr: 1, alignSelf: 'flex-start'}}>
                  <Tooltip title="QA Site" arrow>
                    <PestControl sx={{color: 'red', fontSize: 48, mr: 0.5}} />
                  </Tooltip>
                </Box>
              )}
            </DrawerHeader>

            <List
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  height: '100%',
                }}
            >
              <MainMenuList>
                {/* Events */}
                <List>
                  <NavListItem
                    text="Dashboard"
                    activeIcon={calendar_active}
                    inactiveIcon={calendar}
                    onClick={() => handleNavigate('/')}
                    activePathPatterns={[
                      '/',
                    ]}
                  />
                </List>

                {/* Admin */}
                {hasAdminAccess(user) && (
                  <AdminMainMenu />
                )}
                {/* Approver */}
                {hasApproverAccess(user) && (
                  <ApproverMainMenu />
                )}
                {/* Requestor */}
                {inRequest(user) && (
                  <RequestorMainMenu />
                )}

                <List style={{ marginTop: `auto` }} >
                  {/* Help */}
                  <NavListItem
                    text="Support"
                    activeIcon={<HelpIcon color="primary" />}
                    inactiveIcon={<HelpIcon />}
                    onClick={() => handleNavigate('/support', true)}
                    activePathPatterns={['/support']}
                  />

                  {/* User */}
                  {!user && (
                    <NavListItem
                      text="LogIn/ SignUp"
                      activeIcon={<AccountCircleIcon color="primary" />}
                      inactiveIcon={<AccountCircleIcon />}
                      onClick={handleOpen}
                      activePathPatterns={[]}
                    />
                  )}
                  {user && (
                    <ListItem
                      disablePadding
                      sx={{
                        '&:hover': {
                          backgroundColor: 'rgba(0, 107, 215, 0.1)',
                          cursor: 'pointer'
                        },
                        borderRadius: '9px',
                      }}
                    >
                      <ListItemButton
                        onClick={handleOpenUsers}
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          textAlign: 'center',
                          width: '100%',
                          padding: '8px 4px',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <ListItemIcon sx={{
                          minWidth: 'inherit',
                          margin: '0 auto 4px auto',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: '100%',
                          backgroundColor: 'transparent',
                        }}>
                          <AccountCircleIcon color="primary" style={{ fontSize: '1.6em' }} />
                        </ListItemIcon>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: '10px',
                            fontWeight: 400,
                            lineHeight: '1.2',
                            textAlign: 'center',
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            overflowWrap: 'break-word',
                            hyphens: 'auto',
                            color: '#006BD7',
                            width: '100%',
                            maxWidth: '70px'
                          }}
                        >
                          {username}
                        </Typography>
                      </ListItemButton>
                    </ListItem>
                  )}

                </List>
              </MainMenuList>

              <SecondaryMenuList>
                  {/* Admin */}
                  {hasAdminAccess(user) && (
                    <AdminSubMenu />
                  )}
                  {/* Requestor */}
                  {inRequest(user) && (
                    <RequestorSubMenu />
                  )}
                  {/* User */}
                  {user && (
                    <UsersSubMenu />
                  )}
              </SecondaryMenuList>
            </List>
          </Drawer>
        </ClickAwayListener>
      </Box>
    </>
  )
}
